import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types';
import { Button, Card, Col, Container, Form, Jumbotron, Row } from 'react-bootstrap';
import { useColumns } from '../../hook/useColumns';
import ReactTable from '../../components/helpers/ReactTable';

const ElementsList = ({elements = "", ...props}, context) => {
    
    const {getColumnsConfigurationElements, getColumnsConfigurationElementsInPlan } = useColumns(context);

    const [headerDataConfigurationElementsInPlan, setHeaderDataConfigurationElementsInPlan] = useState(useMemo(() => getColumnsConfigurationElementsInPlan(), []))
    // const [rowsDataConfigurationElementsInPlan, setRowsDataConfigurationElementsInPlan] = useState([]);

    return (
        <>
            <Row>                        
                <Col lg="12">
                    <Form.Label>{context.t("Elements")}</Form.Label>
                    {/* <ReactTable headerData={headerDataConfigurationElementsInPlan} rowsData={elements} actionURI={"/configurationElementsInPlan/remove/"} idReference={"id"} buttonIcon={"delete"}/>                       */}
                    <ReactTable headerData={headerDataConfigurationElementsInPlan} rowsData={elements} />                      
                </Col>
            </Row>
        </>
    );
}

ElementsList.contextTypes = {
    t: PropTypes.func.isRequired
}

export default ElementsList